import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { cartAccountSelector, cartCurrencySelector, cartTotal } from '../redux/selectors/cartSelector';
import { customRound } from "../lib/customRound";

function useTotal(productId) {
    const [productTotal, setProductTotal] = useState('-');

    const currentAccount = useSelector(cartAccountSelector);
    const currency = useSelector(cartCurrencySelector);
    const total = useSelector(state => cartTotal(state, { product_id: productId }));

    useEffect(() => {
        if (total?.total > 0) {
            setProductTotal(
                <>
                    <span dangerouslySetInnerHTML={{ __html: currency?.sign }} />
                    {customRound(total?.total)}
                </>
            );
        } else {
            setProductTotal('-');
        }
    }, [total?.total, currentAccount, currency?.sign]);

    return productTotal;
}

export default useTotal;
